import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

const formatDate = (iso) =>
  new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });

const TypeBadge = ({ type }) =>
  type === 'quote'
    ? <Badge className="bg-[#D94B5A] hover:bg-[#D94B5A] text-white">Quote</Badge>
    : <Badge variant="outline" className="border-gray-400 text-gray-700">Contact</Badge>;

export const LeadsTable = ({ leads }) => {
  if (!leads.length) {
    return (
      <div className="bg-white border border-gray-200 rounded-xl p-12 text-center text-gray-500" data-testid="leads-empty">
        No leads match your filters.
      </div>
    );
  }
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-x-auto" data-testid="leads-table">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Contact</TableHead>
            <TableHead>Insurance / Subject</TableHead>
            <TableHead className="min-w-[280px]">Message</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {leads.map((l) => (
            <TableRow key={l.id} data-testid={`lead-row-${l.id}`}>
              <TableCell className="whitespace-nowrap text-gray-600">{formatDate(l.created_at)}</TableCell>
              <TableCell><TypeBadge type={l.type} /></TableCell>
              <TableCell className="font-medium text-[#1F1F1F]">{l.name}</TableCell>
              <TableCell className="text-sm">
                <a href={`mailto:${l.email}`} className="text-[#D94B5A] hover:underline block">{l.email}</a>
                {l.phone && <a href={`tel:${l.phone.replace(/\D/g, '')}`} className="text-gray-600 hover:underline block">{l.phone}</a>}
              </TableCell>
              <TableCell className="capitalize text-gray-700">{l.topic || '—'}</TableCell>
              <TableCell className="text-sm text-gray-700 whitespace-pre-wrap max-w-md">{l.message || '—'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
